const carouselItems = [
  {
    title: '热血番必看合集',
    desc: '一口气刷完最燃战斗',
    img: 'https://readdy.ai/api/search-image?query=Epic%20Japanese%20shonen%20manga%20style%20illustration%20featuring%20multiple%20hero%20characters%20in%20dynamic%20fighting%20poses%20with%20glowing%20aura%20effects%2C%20dramatic%20perspective%20from%20low%20angle%2C%20vibrant%20orange%20and%20red%20energy%20explosions%2C%20speed%20lines%20and%20action%20impact%20bursts%2C%20dark%20background%20with%20dramatic%20lighting%2C%20high%20contrast%20composition&width=700&height=900&seq=carousel-shonen-collection&orientation=portrait',
  },
  {
    title: '甜宠恋爱大赏',
    desc: '心跳加速的浪漫故事',
    img: 'https://readdy.ai/api/search-image?query=Beautiful%20shojo%20romance%20manga%20illustration%20with%20couple%20characters%20in%20embrace%20surrounded%20by%20floating%20flower%20petals%20and%20sparkles%2C%20soft%20pastel%20pink%20and%20peach%20color%20palette%2C%20dreamy%20atmospheric%20lighting%20with%20lens%20flare%2C%20delicate%20linework%20and%20decorative%20floral%20borders%2C%20romantic%20manga%20cover%20art%20style&width=700&height=900&seq=carousel-romance-collection&orientation=portrait',
  },
  {
    title: '异世界探险专题',
    desc: '打开新世界的大门',
    img: 'https://readdy.ai/api/search-image?query=Fantasy%20isekai%20genre%20manga%20illustration%20with%20adventurer%20characters%20standing%20before%20a%20glowing%20magical%20portal%2C%20medieval%20fantasy%20cityscape%20in%20background%20with%20castles%20and%20dragons%2C%20warm%20golden%20hour%20lighting%2C%20rich%20coral%20and%20amber%20color%20tones%2C%20detailed%20character%20designs%20with%20armor%20and%20magic%20staffs%2C%20epic%20adventure%20atmosphere&width=700&height=900&seq=carousel-isekai-collection&orientation=portrait',
  },
  {
    title: '悬疑推理强推',
    desc: '烧脑反转停不下来',
    img: 'https://readdy.ai/api/search-image?query=Dark%20mystery%20thriller%20manga%20illustration%20with%20detective%20character%20holding%20magnifying%20glass%20in%20dimly%20lit%20room%2C%20crime%20scene%20evidence%20board%20with%20red%20strings%20connecting%20photos%2C%20noir%20atmosphere%20with%20window%20blinds%20casting%20striped%20shadows%2C%20teal%20and%20amber%20color%20scheme%2C%20suspenseful%20cinematic%20composition&width=700&height=900&seq=carousel-mystery-collection&orientation=portrait',
  },
  {
    title: '国漫崛起力作',
    desc: '优秀国风漫画精选',
    img: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20style%20illustration%20with%20martial%20arts%20characters%20in%20traditional%20hanfu%20clothing%2C%20flowing%20ink%20brush%20effects%20and%20watercolor%20textures%2C%20misty%20mountain%20landscape%20with%20ancient%20temples%2C%20elegant%20composition%20inspired%20by%20classical%20Chinese%20painting%2C%20warm%20earthy%20coral%20and%20gold%20accents%2C%20modern%20manhua%20art%20style&width=700&height=900&seq=carousel-chinese-collection&orientation=portrait',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-16 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
            编辑精选
          </h2>
          <p className="text-sm text-foreground-600 max-w-lg mx-auto">
            编辑部精心挑选的漫画专题合集，不容错过
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4">
          {carouselItems.map((item) => (
            <div
              key={item.title}
              className="group rounded-xl overflow-hidden border border-background-200/60 bg-background-50 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="relative aspect-[3/4] overflow-hidden">
                <img
                  src={item.img}
                  alt={`哔咔动漫${item.title}`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
                <div className="absolute bottom-0 left-0 right-0 p-4">
                  <h3 className="font-heading text-sm text-background-50 mb-1">{item.title}</h3>
                  <p className="text-xs text-background-50/70">{item.desc}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}